import styled from 'styled-components';
import GlobalTheme from '../../Themes/SaberLight/Globals';

export const StyledPargraph = styled.p`
  color: ${({ theme }) => theme.fontColour};

  font-family: 'Lato';
  font-size: ${({ theme }) => theme.fontSizeBase};
  letter-spacing: 0.25px;
  line-height: 1.5rem;

  margin: 0 0 1em 0;
`;
StyledPargraph.defaultProps = {
  theme: {
    fontColour: GlobalTheme.black,
    fontSizeBase: GlobalTheme.fontSizeBase,
  },
};
